
type UUID = string;

export class ReviewLabel {
    constructor(public readonly id: UUID, public readonly title: string, public readonly color: string) { }
}
